import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const postUserWelcomeAsset = (params) => {
    const { body, dispatchDisabled, pathsContext } = params;

    if (dispatchDisabled) {
        return VerbFetch(`${pathsContext.serverUrl}/userwelcomeassets`, {
            method: 'POST',
            body
        });
    }

    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_USER_WELCOME_ASSET_START,
            payload: {
                body
            }
        });

        return VerbFetch(`${pathsContext.serverUrl}/userwelcomeassets`, {
            method: 'POST',
            body
        }).then((body) => {
            dispatch({
                type: ACTIONS.POST_USER_WELCOME_ASSET_SUCCESS,
                payload: {
                    welcomeAsset: body
                }
            });
            return body;
        });
    };
};

export const getActiveUserWelcomeAsset = (params) => {
    const { pathsContext, ...rest } = params;
    const url = buildQueryString(rest, `${pathsContext.serverUrl}/userwelcomeassets`);

    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_ACTIVE_USER_WELCOME_ASSET,
                payload: {
                    activeUserWelcomeAsset: body[0]
                }
            });
            return body;
        });
};
